import React from 'react'
import { NavLink } from 'react-router-dom'
import classes from './notfound.module.css'
import error404 from '../../image/error404.svg'

function NotFound() {
  return (
    <div className={classes.error}>
      <img src={error404} alt="error 404" style={{width: '300px', height: '200px'}}/>
      <div>
      <h1 style={{margin: '5px 20px'}}>Page Not found</h1>
      <h3 style={{margin: '5px 20px'}}>The link you clicked may be broken or the page may have been removed.</h3>
      <NavLink to='/' className={classes.broking_link}>Return home?</NavLink>
      </div>
      
    </div>
    
  )
}

export default NotFound
